var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "313px",
    height: "176px",
    viewBox: "0 0 313 176",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "innovation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 313,
    height: 176
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phase-2-Re-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About-us/-desktop",
    transform: "translate(-683.000000, -2269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "component-/-card-/-spot-illustration-+-brand-accent-copy-2",
    transform: "translate(683.000000, 2086.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "innovation",
    transform: "translate(0.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "container"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,0 C25.0714694,0 0,24.6237646 0,55 L112,55 C112,24.6237646 86.9285306,0 56,0 M56,9.91642873 C77.8428289,9.91642873 96.171667,24.978915 100.784011,45.0823633 L11.2159895,45.0823633 C15.828333,24.978915 34.1571711,9.91642873 56,9.91642873",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,110 C86.9285306,110 112,85.3755683 112,55 L0,55 C0,85.3755683 25.0714694,110 56,110",
    id: "Fill-3",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,109 C25.0714694,109 0,133.624305 0,164 L112,164 C112,133.624305 86.9285306,109 56,109",
    id: "Fill-5",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.9f75c37ff39a57d0f3e1c68ffb29a8f5.svg";
export { ForwardRef as ReactComponent };